import { useEffect, useContext, useState } from 'react';
import { loadScript } from '@buzzfeed/bf-utils';
import ABeagleContext from '../../contexts/abeagle';

const KWORDS_SCRIPT_SRC = 'https://sdk.k-words.io/script.js';
const KWORDS_SCRIPT_ID = 'kwords-sdk-script';
const KWORDS_SITE_IDS = {
  bf: '722fd114-46a4-4da4-b910-56375426fefe',
  bfn: 'd2454df9-0fca-41bb-832c-4ffea93028f4',
};

function KWordsScript() {
  const { experiments, getExperimentValue, getFeatureFlagValue } = useContext(ABeagleContext);
  const [enabledOnBF, setEnabledOnBF] = useState(false);
  const [enabledOnBFN, setEnabledOnBFN] = useState(false);

  useEffect(() => {
    if (!experiments.loaded) {
      return;
    }
    if (getExperimentValue('RT-2335-k-words', { rejectErrors: false }) === 'on') {
      setEnabledOnBF(true);
    }
    if( getFeatureFlagValue(
      'RT-2426-k-words-bfnews'
    )) {
      setEnabledOnBFN(true);
    }

  }, [experiments, getExperimentValue, getFeatureFlagValue]);

  useEffect(() => {
    if (!enabledOnBF && !enabledOnBFN) {
      return;
    }

    if (document.getElementById(KWORDS_SCRIPT_ID)) {
      return;
    }

    loadScript(KWORDS_SCRIPT_SRC, document.body, true, {
      id: KWORDS_SCRIPT_ID,
      'data-kwords-site-id': enabledOnBF ? KWORDS_SITE_IDS.bf : KWORDS_SITE_IDS.bfn,
    });
  }, [enabledOnBF, enabledOnBFN]);

  return null;
}

export default KWordsScript;